export abstract class GEOMETRYTYPES {
  public static readonly POINT = 'POINT';
  public static readonly MULTIPOINT = 'MULTIPOINT';
  public static readonly LINESTRING = 'LINESTRING';
  public static readonly MULTILINESTRING = 'MULTILINESTRING';
  public static readonly POLYGON = 'POLYGON';
  public static readonly MULTIPOLYGON = 'MULTIPOLYGON';
  public static readonly RASTER = 'RASTER';
}
